import type { FC } from 'react';

import type { Contact, ContactVariant, PrivateDataType } from '../../../../domain/contact';

import { PrivateDataBlurredItemView } from './PrivateDataItemView';
import { StyledBlurredPrivateData, StyledBlurredItemsWrapper } from './styles';

type Props = {
  contact: Contact;
  variant?: ContactVariant;
};

export const BlurredPrivateDataView: FC<Props> = ({ contact, variant }) => {
  const { hasValidEmails, hasDirectPhoneNumbers, hasMobilePhoneNumbers } = contact;

  const itemsToRender = [
    hasValidEmails && ('email' as PrivateDataType),
    hasDirectPhoneNumbers && ('direct-phone' as PrivateDataType),
    hasMobilePhoneNumbers && ('mobile-phone' as PrivateDataType),
  ].filter((item) => !!item);

  return (
    <StyledBlurredPrivateData data-automation="BlurredPrivateData">
      <StyledBlurredItemsWrapper>
        {itemsToRender.map((type) => (
          <PrivateDataBlurredItemView type={type} variant={variant} key={type} />
        ))}
      </StyledBlurredItemsWrapper>
    </StyledBlurredPrivateData>
  );
};
